// glyph-browser.js
// Builds the glyph grid, handles hover (temp preview) and click (locked preview).

(function () {
  'use strict';

  // ------------------------------------------------------------------ //
  //  Glyph catalogue
  // ------------------------------------------------------------------ //
  var GLYPH_CATEGORIES = [
    {
      label: 'Letters',
      chars: [
        // Uppercase A–Z
        'A','B','C','D','E','F','G','H','I','J','K','L','M',
        'N','O','P','Q','R','S','T','U','V','W','X','Y','Z',
        // Lowercase a–z
        'a','b','c','d','e','f','g','h','i','j','k','l','m',
        'n','o','p','q','r','s','t','u','v','w','x','y','z',
        // Numerals
        '0','1','2','3','4','5','6','7','8','9',
        // Extended Latin – A variants
        'À','Á','Â','Ã','Ä','Å','Ā','Ă','Ą',
        'à','á','â','ã','ä','å','ā','ă','ą',
        'Æ','æ',
        // C variants
        'Ç','Ć','Ĉ','Ċ','Č',
        'ç','ć','ĉ','ċ','č',
        // D variants
        'Ð','Ď','Đ',
        'ð','ď','đ',
        // E variants
        'È','É','Ê','Ë','Ē','Ĕ','Ė','Ę','Ě',
        'è','é','ê','ë','ē','ĕ','ė','ę','ě',
        // G variants
        'Ĝ','Ğ','Ġ','Ģ',
        'ĝ','ğ','ġ','ģ',
        // H variants
        'Ĥ','Ħ',
        'ĥ','ħ',
        // I variants
        'Ì','Í','Î','Ï','Ĩ','Ī','Ĭ','Į','İ',
        'ì','í','î','ï','ĩ','ī','ĭ','į','ı',
        // J variants
        'Ĵ','ĵ',
        // K variants
        'Ķ','ķ','ĸ',
        // L variants
        'Ĺ','Ļ','Ľ','Ŀ','Ł',
        'ĺ','ļ','ľ','ŀ','ł',
        // N variants
        'Ń','Ņ','Ň','Ŋ',
        'ń','ņ','ň','ŉ','ŋ',
        // O variants
        'Ò','Ó','Ô','Õ','Ö','Ø','Ō','Ŏ','Ő','Œ',
        'ò','ó','ô','õ','ö','ø','ō','ŏ','ő','œ',
        // R variants
        'Ŕ','Ŗ','Ř',
        'ŕ','ŗ','ř',
        // S variants
        'Ś','Ŝ','Ş','Š','ẞ',
        'ś','ŝ','ş','š','ß',
        // T variants
        'Ţ','Ť','Ŧ','Þ',
        'ţ','ť','ŧ','þ',
        // U variants
        'Ù','Ú','Û','Ü','Ũ','Ū','Ŭ','Ů','Ű','Ų',
        'ù','ú','û','ü','ũ','ū','ŭ','ů','ű','ų',
        // W variants
        'Ŵ','ŵ',
        // Y variants
        'Ý','Ÿ','Ŷ',
        'ý','ÿ','ŷ',
        // Z variants
        'Ź','Ż','Ž',
        'ź','ż','ž',
        // Misc
        'Ə','ə'
      ]
    },
    {
      label: 'Punctuation & Symbols',
      chars: [
        '.', ',', ';', ':', '!', '¡', '?', '¿',
        '\u2018', '\u2019', '\u201C', '\u201D', '\u0027', '\u0022',
        '/', '\\', '|', '‖',
        '-', '\u2013', '\u2014', '_',
        '(', ')', '[', ']', '{', '}', '⟨', '⟩',
        '@', '#', '%', '‰', '&', '*',
        '†', '‡', '¶', '§',
        '©', '®', '™',
        '°', '′', '″',
        '…', '·', '•',
        '‹', '›', '«', '»',
        '~', '^', '`',
        '№', 'ℓ', '℮'
      ]
    },
    {
      label: 'Currency',
      chars: [
        '$', '¢', '£', '€', '¥',
        '₹', '₽', '₩', '₪', '₫',
        '₦', '₡', '₱', '₲', '₴',
        '₵', '₸', '₺', '₼', '₾', '¤'
      ]
    },
    {
      label: 'Arrows & Math',
      chars: [
        '←', '→', '↑', '↓',
        '↖', '↗', '↘', '↙',
        '↔', '↕',
        '⟵', '⟶', '⟷',
        '+', '−', '×', '÷',
        '=', '≠', '<', '>',
        '≤', '≥', '±', '≈',
        '≡', '∞', '√', '∑',
        '∏', '∫', '∂', '∆', '∇',
        '½', '¼', '¾',
        '⅓', '⅔', '⅛', '⅜', '⅝', '⅞',
        '⁰', '¹', '²', '³',
        '⁴', '⁵', '⁶', '⁷', '⁸', '⁹'
      ]
    }
  ];

  // ------------------------------------------------------------------ //
  //  Init
  // ------------------------------------------------------------------ //
  function init() {
    var section = document.querySelector('[data-glyph-browser]');
    if (!section) return;

    var font    = section.dataset.gbFont;
    var fvs     = section.dataset.gbFvs;
    var gridCol = section.querySelector('[data-gb-grid]');
    var preview = section.querySelector('[data-gb-preview]');

    var lockedGlyph  = 'a';
    var hoveredGlyph = null;

    // Apply font to preview
    preview.style.fontFamily           = '"' + font + '", sans-serif';
    preview.style.fontVariationSettings = fvs;
    preview.textContent                = lockedGlyph;

    // Build each category
    GLYPH_CATEGORIES.forEach(function (cat) {
      var catEl = document.createElement('div');
      catEl.className = 'gb-category';

      var labelEl = document.createElement('div');
      labelEl.className   = 'gb-category__label';
      labelEl.textContent = cat.label;
      catEl.appendChild(labelEl);

      var glyphGrid = document.createElement('div');
      glyphGrid.className = 'gb-grid';

      cat.chars.forEach(function (char) {
        var btn = document.createElement('button');
        btn.className  = 'gb-cell';
        btn.textContent = char;
        btn.type       = 'button';
        btn.setAttribute('aria-label', 'Preview ' + char);
        btn.style.fontFamily            = '"' + font + '", sans-serif';
        btn.style.fontVariationSettings = fvs;

        if (char === lockedGlyph) btn.classList.add('is-locked');

        btn.addEventListener('mouseenter', function () {
          hoveredGlyph = char;
          updatePreview();
        });

        btn.addEventListener('mouseleave', function () {
          hoveredGlyph = null;
          updatePreview();
        });

        btn.addEventListener('click', function () {
          // Unlock previous
          section.querySelectorAll('.gb-cell.is-locked').forEach(function (c) {
            c.classList.remove('is-locked');
          });
          lockedGlyph = char;
          btn.classList.add('is-locked');
          updatePreview();
        });

        glyphGrid.appendChild(btn);
      });

      catEl.appendChild(glyphGrid);
      gridCol.appendChild(catEl);
    });

    function updatePreview() {
      preview.textContent = hoveredGlyph !== null ? hoveredGlyph : lockedGlyph;
    }

    // ---- Font coverage filter ----
    // Wait until the font is actually loaded into the canvas context before
    // checking pixel output, otherwise everything falls back to monospace.
    var loadPromise = (document.fonts && document.fonts.load)
      ? document.fonts.load('400 24px "' + font + '"')
      : Promise.resolve();

    loadPromise.then(function () {
      filterUnsupported(font, gridCol);
    });
  }

  // ------------------------------------------------------------------ //
  //  Font coverage detection
  //  Renders each character twice:
  //    d1 — with the real target font first in the stack
  //    d2 — with a deliberately nonexistent font first (same fallback chain)
  //  When the target font LACKS a glyph, both canvases fall through the
  //  identical OS cascade (Apple Symbols, Segoe UI Symbol, etc.) and
  //  produce the same pixels → unsupported.
  //  When the target font HAS the glyph, d1 uses it and looks different
  //  from d2's fallback render → supported.
  //  Comparing against a fixed font like `monospace` was unreliable because
  //  the OS cascade reaches symbol fonts BEFORE monospace for many chars.
  // ------------------------------------------------------------------ //
  function isCharSupported(ctx, char, font) {
    var w = ctx.canvas.width;
    var h = ctx.canvas.height;
    var y = Math.round(h * 0.8);

    // Draw with target font
    ctx.clearRect(0, 0, w, h);
    ctx.font = '400 ' + h + 'px "' + font + '", sans-serif';
    ctx.fillText(char, 2, y);
    var d1 = ctx.getImageData(0, 0, w, h).data;

    // Draw with a fake font name — forces same OS fallback path as above
    // but without the target font, so unsupported chars render identically
    ctx.clearRect(0, 0, w, h);
    ctx.font = '400 ' + h + 'px "__gb_ref__", sans-serif';
    ctx.fillText(char, 2, y);
    var d2 = ctx.getImageData(0, 0, w, h).data;

    // Both renders blank → whitespace / invisible char → treat as supported
    var anyPixel = false;
    for (var i = 3; i < d1.length; i += 4) {
      if (d1[i] > 8 || d2[i] > 8) { anyPixel = true; break; }
    }
    if (!anyPixel) return true;

    // Any pixel difference → font has its own glyph
    for (var j = 0; j < d1.length; j++) {
      if (d1[j] !== d2[j]) return true;
    }
    return false;
  }

  function filterUnsupported(font, gridCol) {
    var SIZE = 32;
    var canvas = document.createElement('canvas');
    canvas.width  = 40;
    canvas.height = SIZE;
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.fillStyle = '#fff';

    var catEls = gridCol.querySelectorAll('.gb-category');
    catEls.forEach(function (catEl) {
      var cells = catEl.querySelectorAll('.gb-cell');
      var visible = 0;
      cells.forEach(function (cell) {
        if (isCharSupported(ctx, cell.textContent, font)) {
          visible++;
        } else {
          cell.style.display = 'none';
        }
      });
      // Hide the whole category label+grid if nothing is supported
      if (visible === 0) catEl.style.display = 'none';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
